import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey) || localStorage.getItem(TokenKey)
}

export function setToken(val) {
  localStorage.setItem(TokenKey,val)
  return Cookies.set(TokenKey, val)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
  return Cookies.remove(TokenKey)
}

/**
 * 从缓存的menuList中获取orgId
 * @returns {string|null} orgId或null
 */
export function getCachedOrgId() {
  try {
    const menuListStr = localStorage.getItem('menuList')
    if (menuListStr) {
      const menuList = JSON.parse(menuListStr)
      return menuList?.orgId || null
    }
    return null
  } catch (error) {
    console.warn('获取缓存orgId失败:', error)
    return null
  }
}
